module.exports = function () {
    $('.product-hero-module').each(function () {
        var $productHeroModule = $(this);
        var $productHeroModuleContentContainer = $productHeroModule.find('.product-hero-module__content-container').first();
        var containerWidth = $productHeroModuleContentContainer.width();
        var containerHeight = $productHeroModuleContentContainer.outerHeight();
        $productHeroModuleContentContainer.find('.product-hero-module__background-video-wrapper').css('height', containerHeight + 'px');
        $productHeroModuleContentContainer.find('.wistia_responsive_padding').css('width', containerWidth + 'px').css('height', containerHeight + 'px').css('padding-top', 0);        
        $productHeroModuleContentContainer.find('[id^="wistia_chrome"]').css('width', containerWidth + 'px').css('height', containerHeight + 'px');        
    });
};